// src/utils/labelUtils.js

/**
 * Maps internal field names (project, dataset) to platform-specific labels.
 * Keeps your internal model stable while showing friendly names in the UI.
 */
export function labelFor(field, platform) {
  const map = {
    project: {
      bigquery: "Project",
      snowflake: "Database",
      databricks: "Catalog",
      redshift: "Database",
      postgres: "Database",
      synapse: "Database",
    },
    dataset: {
      bigquery: "Dataset",
      snowflake: "Schema",
      databricks: "Schema",
      redshift: "Schema",
      postgres: "Schema",
      synapse: "Schema",
    },
  };

  return map[field]?.[platform?.toLowerCase?.()] || field;
}

// Centralized list of supported platforms
export const PLATFORMS = [
  "bigquery",
  "snowflake",
  "databricks",
  "redshift",
  "postgres",
  "sqlite",
  "synapse",
];
